module.exports = __webpack_public_path__ + "img/shop-Info1.eca4d990.png";